<template>
  <div class="card-block">
    <div class="form-group row">
      <div class="col-md-10 pb-2">
        <h5>
          <strong><i class="fas fa-address-book"></i> Contatos</strong>
        </h5>
      </div>
      <div class="col-md-2">
        <a
          v-if="!isBusyContato"
          href="javascript:void(0);"
          @click="toggleBusyContato"
        >
          <i
            class="fas fa-eye-slash"
            style="font-size: 16px"
            v-b-tooltip.hover
            :title="'Minimizar Dados'"
          ></i>
        </a>
        <a
          v-else
          href="javascript:void(0);"
          @click="toggleBusyContato"
        >
          <i
            class="fas fa-eye"
            style="font-size: 16px"
            v-b-tooltip.hover
            :title="'Mostrar Dados'"
          ></i>
        </a>
      </div>
    </div>
    <div v-if="phones && !isBusyContato">
      <div class="table-responsive pt-2 pl-4 pr-4">
        <table
          class="table table-hover"
          style="border: 1px solid #dcdede"
        >
          <thead
            class="thead-third"
            style="border: solid 1px #04a791; font-size: 12px"
          >
            <tr>
              <th class="text-center">CONTATO</th>
              <th class="text-center">TIPO</th>
              <th class="text-center">AÇÕES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(obj, index) in phones"
              :key="index"
            >
              <td
                class="text-center"
                style="padding: 8px"
              >
                <a :href="`tel:${obj.telefone}`">{{ obj.telefone }}</a>
              </td>
              <td
                class="text-center"
                style="font-size: 11px; padding: 8px"
              >
                {{ obj.tipoContato }}
              </td>
              <td
                @click="openShowMessages(objSelected, obj.telefone)"
                class="text-center"
                style="font-size: 14px; cursor: pointer; padding: 8px"
              >
                <i
                  :class="
                    obj.tipoContato === 'CELULAR'
                      ? 'fab fa-whatsapp'
                      : 'fas fa-phone-alt'
                  "
                ></i>
              </td>
            </tr>
            <tr v-if="mail">
              <td
                class="text-center"
                style="padding: 8px"
              >
                <a :href="`mailto:${mail}`">{{ mail }}</a>
              </td>
              <td
                class="text-center"
                style="font-size: 11px; padding: 8px"
              >
                E-MAIL
              </td>
              <td
                @click="toastInfo"
                class="text-center"
                style="font-size: 14px; cursor: pointer; padding: 8px"
              >
                <i class="fas fa-mail-bulk"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <AssociateCreate
      class="pos"
      ref="newConversationModal"
      :conversationInfo="conversationAssociate"
    />
  </div>
</template>

<script>
import AssociateCreate from './associateCreate.vue'

export default {
  name: 'AssociateContato',
  props: {
    phones: {
      type: Array
    },
    mail: {
      type: String,
      default: ''
    }
  },
  components: {
    AssociateCreate
  },
  data () {
    return {
      isBusyContato: true
    }
  },
  methods: {
    toggleBusyContato () {
      this.isBusyContato = !this.isBusyContato
    },
    openShowMessages (conversationAssociate, telefone) {
      this.conversationAssociate = conversationAssociate
      this.$refs.newConversationModal.openModal(conversationAssociate, telefone)
    },
    toastInfo () {
      this.$toast.info('Ação de contato clicada!')
    }
  }
}
</script>

  <style scoped>
.input-group {
  font-size: 14px;
}
.card-block {
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateContato.vue